(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velavio-discount-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velavio-discount-popup')) {
    customElements.define(
      'velavio-discount-popup',
      class VelavioDiscountPopup extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.dialog = this.querySelector('dialog');
          this.closeButton = this.querySelector('[data-popup-close]');
          this.copyButton = this.querySelector('[data-popup-copy]');
          this.submitButton = this.querySelector('[data-popup-submit]');
          this.form = this.closest('form');
          this.handleClose = () => this.dialog?.close();
          this.handleBackdrop = (event) => {
            if (event.target === this.dialog) this.dialog.close();
          };
          this.handleExit = (event) => {
            if (event.clientY <= 0) this.requestOpen();
          };
          this.handleSectionSelect = (event) => {
            if (event.detail?.sectionId === this.dataset.sectionId) this.open(true);
          };
          this.handleSectionDeselect = (event) => {
            if (event.detail?.sectionId === this.dataset.sectionId && this.dialog?.open) this.dialog.close();
          };
          this.closeButton?.addEventListener('click', this.handleClose);
          this.dialog?.addEventListener('click', this.handleBackdrop);
          this.copyButton?.addEventListener('click', () => this.copyCode());
          this.form?.addEventListener('submit', () => {
            this.submitButton?.setAttribute('aria-busy', 'true');
          });
          document.addEventListener('shopify:section:select', this.handleSectionSelect);
          document.addEventListener('shopify:section:deselect', this.handleSectionDeselect);

          if (this.dataset.success === 'true') {
            this.writeState('submitted');
            queueMicrotask(() => this.open(true));
            return;
          }

          if (this.dataset.hasErrors === 'true') {
            queueMicrotask(() => this.open(true));
            return;
          }

          if (this.dataset.enabled !== 'true' || this.dataset.designMode === 'true' || this.hasActiveState()) return;

          if (this.isMobile()) {
            this.timer = window.setTimeout(() => this.requestOpen(), Number(this.dataset.mobileDelay));
          } else if (this.dataset.desktopTrigger === 'delay') {
            this.timer = window.setTimeout(() => this.requestOpen(), Number(this.dataset.desktopDelay));
          } else {
            this.armTimer = window.setTimeout(() => {
              document.documentElement.addEventListener('mouseleave', this.handleExit);
            }, 3000);
          }
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          window.clearTimeout(this.armTimer);
          document.documentElement.removeEventListener('mouseleave', this.handleExit);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
          document.removeEventListener('shopify:section:deselect', this.handleSectionDeselect);
        }

        isMobile() {
          return window.innerWidth < 990 || window.matchMedia('(pointer: coarse)').matches;
        }

        pageIsBusy() {
          return Boolean(
            document.querySelector('cart-drawer.active, cart-notification.active, .drawer.active, [id*="CartDrawer"][open]') ||
              document.body.classList.contains('overflow-hidden')
          );
        }

        requestOpen() {
          if (this.pageIsBusy()) {
            if (this.isMobile()) this.timer = window.setTimeout(() => this.requestOpen(), 10000);
            return;
          }
          this.open(false);
        }

        open(force) {
          if (!this.dialog || this.dialog.open || (!force && this.hasActiveState())) return;
          if (!force) this.writeState('seen');
          this.dialog.showModal();
          const focusTarget = this.querySelector('[data-popup-success]') || this.querySelector('input');
          focusTarget?.focus({ preventScroll: true });
          document.documentElement.removeEventListener('mouseleave', this.handleExit);
        }

        hasActiveState() {
          try {
            const state = JSON.parse(localStorage.getItem(this.dataset.storageKey));
            if (!state) return false;
            if (state.status === 'submitted') return true;
            const duration = Number(this.dataset.frequencyDays) * 86400000;
            return Date.now() - Number(state.time) < duration;
          } catch (error) {
            return false;
          }
        }

        writeState(status) {
          try {
            localStorage.setItem(this.dataset.storageKey, JSON.stringify({ status, time: Date.now() }));
          } catch (error) {
            return;
          }
        }

        async copyCode() {
          const code = this.querySelector('[data-popup-code]')?.textContent?.trim();
          if (!code || !this.copyButton) return;
          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          const copiedLabel = this.copyButton.dataset.copiedLabel;
          this.copyButton.textContent = copiedLabel;
          const status = this.querySelector('[data-popup-status]');
          if (status) status.textContent = copiedLabel;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
